<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :multiple="multiple"
            :dense="dense"
            @change="$emit('change', $event)"
            :disabled="disabled"
            :selectAll="selectAll"
            :autoComplete="autoComplete"
            :outlined="outlined"
            :hideDetails="hideDetails"
        >
            <template v-if="showSlotItem" v-slot:dataItem="{ item }">
                {{ item.name }}
            </template>
        </sys-select-base>
        <sys-register-campus @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectCampus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        showSlotItem: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        branchId:{

        },
        brandId:{

        },
        institutionId:{

        },
        educationalGroupId:{

        },
        filterRelation: {

        },
        loadOnlyWithRelation: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        onlyActive: {
            type: Boolean,
            default: false
        },

        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
    },

    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        branchId(){
            this.getItems();
        },

        brandId(){
            this.getItems();
        },

        institutionId(){
            this.getItems();
        },

        educationalGroupId(){
            this.getItems();
        },

    },
    methods: {
        ...mapActions('campus', ['ActionFindCampuses']),        
        
        async getItems() {

            if(this.loadOnlyWithRelation && !this.filterRelation) {
                return;
            }
            
            this.loading = true;
            let payload = {
                column_order: 'name',
                columns: 'id,name,code',
            };

            if(this.branchId){
                payload.find_columns = {
                    branch_id: this.branchId,
                };
            }

            if(this.brandId){
                
                if(!payload.find_columns){
                    payload.find_columns = {};
                }

                payload.find_columns.brand_id = this.brandId;
                
            }

            if(this.institutionId){
                
                if(!payload.find_columns){
                    payload.find_columns = {};
                }

                payload.find_columns.institution_id = this.institutionId;
                
            }

            if(this.educationalGroupId){
                
                if(!payload.find_columns){
                    payload.find_columns = {};
                }

                payload.find_columns.educational_group_id = this.educationalGroupId;
                
            }

            if(this.filterRelation){
                
                if(this.filterRelation == 'ambiences'){
                    payload.filter_relations = [
                        {
                            name: this.filterRelation,
                            key: 'active',
                            value: 1
                        },
                    ]
                }else{
                    payload.filter_relations = [
                        {
                            name: this.filterRelation,
                        },
                    ]
                }
                
                
            }

            if(this.multiple){
                this.selected = [];
            }else{
                this.selected = null;
            }

            if(this.onlyActive){
                if(!payload.find_columns){
                    payload.find_columns = {};
                }

                payload.find_columns.active = 1;
            }

            await this.ActionFindCampuses(payload)
                    .then((res) => {
                        
                        this.items = res.data;
                        this.selected = this.model;
                        
                        if(this.required && !this.model && this.items.length == 1){
                            
                            if(this.multiple){
                                this.selected = [this.items[0]];
                            }else{
                                this.selected = this.items[0];
                            }
                            
                        }

                        this.$emit('loaded', this.items);

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>
